import { AdElementText, DateTimeFormat } from '@adflow/types';
import { FormLabel, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import { FC, useCallback } from 'react';
import { useStore } from '../../../../hooks/useStore';

type Props = {
  textElement: AdElementText;
};

export const isDayPresent = (textElement: AdElementText) => {
  if (!textElement.sources[0]) return false;
  return textElement.data.content.includes(`${textElement.sources[0].sourceId}:DAY}`);
};

const DayFormatControls: FC<Props> = ({ textElement }) => {
  const s = useStore((state) => ({
    displayOptions: state.displayOptions,
    setElementDateDisplayOptions: state.setElementDateDisplayOptions,
  }));

  const dateDisplayOptions: DateTimeFormat | null | undefined =
    textElement.data.dateDisplayOptions || s.displayOptions.dateTimeFormat;

  const handleUpdateDayFormat = useCallback(
    (value: string) => {
      let dayFormat = dateDisplayOptions?.dayFormat;
      if (dayFormat == null) {
        dayFormat = 'long';
      }

      if (value !== 'short' && value !== 'long') return;
      dayFormat = value;
      s.setElementDateDisplayOptions(textElement.id, {
        ...dateDisplayOptions,
        dayFormat: dayFormat,
      });
    },
    [s, dateDisplayOptions, textElement.id],
  );

  return (
    <>
      <Stack direction="row" mb={2}>
        <FormLabel htmlFor="time-format" mb={'0'} style={{ fontVariant: 'all-small-caps' }}>
          Day
        </FormLabel>
        <RadioGroup
          value={dateDisplayOptions?.dayFormat || 'long'}
          id="time-format"
          ml={'auto'}
          mr={0}
          onChange={handleUpdateDayFormat}
        >
          <Stack direction="row">
            <Radio value="short">Abbreviated</Radio>
            <Radio value="long">Full</Radio>
          </Stack>
        </RadioGroup>
      </Stack>
    </>
  );
};

DayFormatControls.displayName = 'DayFormatControls';

export default DayFormatControls;
